import { createBrowserRouter } from "react-router-dom";
import "./App.css";
import { getUser } from "./utils";
import {
  AvailableBerth,
  BerthDetail,
  BlogDetail,
  BlogPage,
  Cart,
  CreateBerth,
  Dashboard,
  DockingMate,
  ForgotPassword,
  General,
  Home,
  Login,
  PastBerths,
  PaymentFailed,
  PaymentSuccess,
  Profile,
  ResetPassword,
  UpdateProfile,
  PrivacyPolicy,
  About,
  HowItWorks,
  PaymentAccount,
  NotFound,
} from "./pages";
import { LightSignup } from "./pages/auth/lightSignup/LightSignup";
import { UserProvider } from "./contexts/UserContext";

export const router = createBrowserRouter([
  // general paths
  {
    path: "/",
    element: <DockingMate />,
    loader: getUser,
  },
  {
    path: "/blog",
    element: <BlogPage />,
    loader: getUser,
  },
  {
    path: "/blog-detail",
    element: <BlogDetail />,
    loader: getUser,
  },
  {
    path: "/general",
    element: <General />,
    loader: getUser,
  },
  {
    path: "/payment-success",
    element: <PaymentSuccess />,
    loader: getUser,
  },
  {
    path: "/payment-failed",
    element: <PaymentFailed />,
    loader: getUser,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    loader: getUser,
  },
  {
    path: "/about-us",
    element: <About />,
    loader: getUser,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
    loader: getUser,
  },

  // auth path
  {
    path: "/login",
    element: <Login />,
    loader: getUser,
  },
  {
    path: "/signup",
    element: <LightSignup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },

  // yacht path
  {
    path: "/home",
    element: (
      <UserProvider>
        <Home />
      </UserProvider>
    ),
    loader: getUser,
    children: [
      {
        path: "",
        element: <Dashboard />,
        loader: getUser,
      },
      {
        path: "berth-detail",
        element: <BerthDetail />,
        loader: getUser,
      },
      {
        path: "available-berths",
        element: <AvailableBerth />,
        loader: getUser,
      },
      {
        path: "cart",
        element: <Cart />,
        loader: getUser,
      },
      {
        path: "past-berths",
        element: <PastBerths />,
        loader: getUser,
      },
      {
        path: "create-berth",
        element: <CreateBerth />,
        loader: getUser,
      },
      {
        path: "profile",
        element: <Profile />,
        loader: getUser,
      },
      {
        path: "payment-account",
        element: <PaymentAccount />,
        loader: getUser,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
    loader: getUser,
  }
]);
